// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"77b91d85","349":"53d9cea5","554":"0d7df427","687":"2f970b34","813":"e023f94c","963":"10382349","989":"f5269b7e"}[chunkId] + ".chunk.js";
};